class SkipTypes {
	static Invalid = 0;
	static ClientRequest = 1;
	static Emergency = 2;
	static IncorrectCopy = 3;
	static EventChange = 4;
	static RecentNewsEvent = 5;
	static Other = 6;
}

export default SkipTypes;